import { TDashletValueBreakdownResponseData } from '../dashboard.consts';

export function addValueBreakdownLabels(response: TDashletValueBreakdownResponseData): string[] {
  return Object.keys(response.data).map((label) => `${label}`);
}
